import React, { Component } from 'react';
import styleable from 'react-styleable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cloneDeep from 'lodash/cloneDeep';
import PropTypes from 'prop-types';
import { DatePicker, DataTable } from '@3plearning/react-components';
import css from './student.scss';
import studentActions, {
    LIVE_MATHS_STUDENT_RETRIEVED
} from './student-actions';
import {
    SELECTED_DATE,
    SELECTED_STUDENT,
    SELECTED_CLASS
} from '../../../components/report-filters/filter-constants';
import { activeFiltersPropType } from '../../../components/report-filters/filter-prop-types';
import activeFiltersActions from '../../../components/report-filters/redux/active-filters/active-filters-actions';
import {
    STUDENT_TABLE_CONFIG,
    STUDENT_FOOTER_DATA,
    STUDENT_DISCLAIMER
} from './student-constants';
import TableHeader from '../../../components/table-header/table-header';
import activeFiltersSelectors from '../../../components/report-filters/redux/active-filters/active-filters-selectors';
import { liveMathsResultPropType } from './student-prop-types';
import FilterHelper from '../../../helpers/filter-helper';
import { translateTableLabels } from '../../../helpers/locale-helpers';

/**
 * Displays live maths results for an individual student
 */
export class Student extends Component {
    static propTypes = {
        liveMathsData: PropTypes.shape({
            liveMathsResults: PropTypes.arrayOf(liveMathsResultPropType)
        }),
        activeFilters: activeFiltersPropType,
        getLiveMathsData: PropTypes.func,
        updateActiveFilter: PropTypes.func,
        invalidRequest: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.i18n = window.i18n;
        this.state = { studentTableConfig: null };
    }

    componentDidMount() {
        const { activeFilters } = this.props;
        if (FilterHelper.shouldLoadStudent(activeFilters)) {
            this.getStudentLiveMathsData(
                activeFilters[SELECTED_STUDENT].id,
                activeFilters[SELECTED_CLASS].id,
                activeFilters[SELECTED_DATE]
            );
            this.setStudentDataConfig();
        }
    }

    componentWillReceiveProps(newProps) {
        const {
            activeFilters,
            invalidRequest,
            updateActiveFilter
        } = this.props;
        const {
            activeFilters: newActiveFilters,
            invalidRequest: newInvalidRequest
        } = newProps;

        // user's selection has changed (date or student), need to request data from backend
        if (FilterHelper.shouldReloadStudent(activeFilters, newActiveFilters)) {
            this.getStudentLiveMathsData(
                newActiveFilters[SELECTED_STUDENT].id,
                newActiveFilters[SELECTED_CLASS].id,
                newActiveFilters[SELECTED_DATE]
            );
        }

        // request to backend failed, attempt to load page using default values
        if (
            invalidRequest !== newInvalidRequest &&
            newInvalidRequest === LIVE_MATHS_STUDENT_RETRIEVED
        ) {
            if (
                newActiveFilters[SELECTED_DATE].type !==
                DatePicker.THIS_SCHOOL_YEAR
            ) {
                updateActiveFilter(SELECTED_DATE, {
                    type: DatePicker.THIS_SCHOOL_YEAR
                });
            }
        }
    }

    getStudentLiveMathsData(studentId, classId, selectedDateFilter) {
        this.props.getLiveMathsData(studentId, classId, selectedDateFilter);
    }

    setStudentDataConfig() {
        let studentTableConfig = cloneDeep(STUDENT_TABLE_CONFIG);
        studentTableConfig = translateTableLabels(studentTableConfig);
        this.setState({ studentTableConfig });
    }

    render() {
        const { liveMathsData } = this.props;
        const { studentTableConfig } = this.state;
        return (
            <div className={css.component}>
                <div className={css['live-maths-results']}>
                    <TableHeader
                        title={'Label - LiveMathleticsReport'}
                        translate
                    />
                    {studentTableConfig && (
                        <DataTable
                            config={studentTableConfig}
                            data={
                                liveMathsData && liveMathsData.liveMathsResults
                            }
                            footerData={this.i18n._(STUDENT_FOOTER_DATA)}
                        />
                    )}
                    <span className={css.disclaimer}>
                        {this.i18n._(STUDENT_DISCLAIMER)}
                    </span>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        activeFilters: activeFiltersSelectors.selectActiveFilters(state),
        liveMathsData: state.liveMathsStudent,
        invalidRequest: state.invalidRequest
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            getLiveMathsData: studentActions.getLiveMathsData,
            updateActiveFilter: activeFiltersActions.updateActiveFilter
        },
        dispatch
    );
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(styleable(css)(Student));



// WEBPACK FOOTER //
// ./containers/live-maths/student/student.js